// extracted by mini-css-extract-plugin
export default {"section":"Faq_section__0iPkO","title":"Faq_title__s85uc","sectionItem":"Faq_sectionItem__+IinM","sectionItemTitle":"Faq_sectionItemTitle__ll4nM"};